import type { ReactNode } from 'react';

export const symbol_timer_3_select: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M421-200H200q-16.67 0-28.33-11.74Q160-223.47 160-240.24q0-16.76 11.67-28.26Q183.33-280 200-280h221v-160H202q-16.67 0-28.33-11.74Q162-463.47 162-480.24q0-16.76 11.67-28.26Q185.33-520 202-520h219v-160H200q-16.67 0-28.33-11.74Q160-703.47 160-720.24q0-16.76 11.67-28.26Q183.33-760 200-760h221q33.33 0 56.67 23.33Q501-713.33 501-680v131q0 29-19.25 50T435-478q27.5 0 46.75 19.54T501-411v131q0 33.33-23.33 56.67Q454.33-200 421-200Zm377 0H630q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h150v-70H642q-17 0-29.5-12.5T600-372v-106q0-17 12.5-29.5T642-520h168q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H660v70h138q17 0 29.5 12.5T840-348v106q0 17-12.5 29.5T798-200Z"
		/>
	</svg>
);
